import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AzmoonMaharatDetail_Files_Interface, Empty_AzmoonMaharatDetail_Files_Interface } from 'src/app/Interface/AzmoonMaharatDetail_Files_Interface';
import { AzmoonMaharatDetail_Interface, Empty_AzmoonMaharatDetail_Interface } from 'src/app/Interface/AzmoonMaharatDetail_Interface';
import { AzmoonMaharatMain_Interface, Empty_AzmoonMaharatMain_Interface } from 'src/app/Interface/AzmoonMaharatMain_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { AzmoonMaharatService } from 'src/app/Service/AzmoonMaharat/AzmoonMaharat.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-AzmoonMaharatDetailForm',
  templateUrl: './AzmoonMaharatDetailForm.component.html',
  styleUrls: ['./AzmoonMaharatDetailForm.component.scss']
})
export class AzmoonMaharatDetailFormComponent implements OnInit {

  @Input() inner_AzmoonMaharatDetail: AzmoonMaharatDetail_Interface = Empty_AzmoonMaharatDetail_Interface()
  @Input() inner_AzmoonMaharat: AzmoonMaharatMain_Interface = Empty_AzmoonMaharatMain_Interface()

  @Output() outter_AzmoonMaharatDetail = new EventEmitter<number>();
  InProccessing: boolean = false
  modalRef_Delete: any;
  page: any

  constructor(
    private AzmoonMaharat_Service: AzmoonMaharatService,
    private modalService: BsModalService,
    private Alertify_Service: AlertifyService
  ) { }

  ngOnInit() {

    this.AzmoonMaharatForm = new FormGroup({
      id: new FormControl(),
      title: new FormControl(null, Validators.required),
      startDate: new FormControl(null, Validators.required),
      endDate: new FormControl(null, Validators.required),
    })

    this.AzmoonMaharatFileForm = new FormGroup({
      title: new FormControl(null, Validators.required),
      templateSrc: new FormControl(null, Validators.required),
    })

    if (this.inner_AzmoonMaharatDetail.id > 0) {
      this.get_Form_title().setValue(this.inner_AzmoonMaharatDetail.title + '')
      this.get_Form_startDate().setValue(this.inner_AzmoonMaharatDetail.startDate + '')
      this.get_Form_endDate().setValue(this.inner_AzmoonMaharatDetail.endDate + '')
      this.FileDataLise = this.inner_AzmoonMaharatDetail.file
    }

  }

  //#region  Form Add

  AzmoonMaharatForm: FormGroup;

  get_Form_title() {
    return this.AzmoonMaharatForm.get('title') as FormControl;
  }
  get_Form_startDate() {
    return this.AzmoonMaharatForm.get('startDate') as FormControl;
  }
  get_Form_endDate() {
    return this.AzmoonMaharatForm.get('endDate') as FormControl;
  }

  //#endregion

  //#region  Form File

  AzmoonMaharatFileForm: FormGroup;

  get_FormFile_title() {
    return this.AzmoonMaharatFileForm.get('title') as FormControl;
  }
  get_FormFile_templateSrc() {
    return this.AzmoonMaharatFileForm.get('templateSrc') as FormControl;
  }


  //#endregion

  //#region Files
  BaseUrl = environment.BaseUrl+"File/AzmoonMaharat/"
  FileDataLise:Array<AzmoonMaharatDetail_Files_Interface>=[]
  OnSubmitFile() {

    var temp: AzmoonMaharatDetail_Files_Interface = Empty_AzmoonMaharatDetail_Files_Interface()
    temp.id = 0
    temp.title = this.get_FormFile_title().value
    temp.templateSrc = this.get_FormFile_templateSrc().value

    this.FileDataLise.push(temp)

    this.Alertify_Service.SuccessMessage("فایل به لیست اضافه شد")
  }

  RemoveFile(id:number)
  {
    this.FileDataLise.splice(id,1)
    this.Alertify_Service.SuccessMessage("فایل از لیست حذف شد")
  }

  //#endregion


  OnSubmit() {

    var temp: AzmoonMaharatDetail_Interface = Empty_AzmoonMaharatDetail_Interface()
    temp.id = this.inner_AzmoonMaharatDetail.id
    temp.title = this.get_Form_title().value
    temp.startDate = this.get_Form_startDate().value
    temp.endDate = this.get_Form_endDate().value


    this.InProccessing = true
    this.AzmoonMaharat_Service.AddEditDetail(temp, 
      this.inner_AzmoonMaharat.id,
      this.FileDataLise).subscribe(
      data => {
        this.InProccessing = false
        if (data.id == -2)
          this.Alertify_Service.ErrorMessage("عنوان در سامانه موجود است")
        else {
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          if (this.inner_AzmoonMaharatDetail.id == 0)
            this.AzmoonMaharatForm.reset()
        }
      }
    )


  }

  UploadTemplate(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.AzmoonMaharat_Service.uploadFile(formData).subscribe(
      data => {
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.get_FormFile_templateSrc().setValue(data['filename'])
        }
      }
    )

  }


  onBack() {
    this.outter_AzmoonMaharatDetail.emit(-1);
  }

}
